<template>
  <div class="dealers">
    <v-user-create-update-form v-if="this.isShowModal" @close="closeModal" />

    <div class="row pb-3">
      <div class="col-lg-8">
        <h5>Всего: {{ dealerList.count }}</h5>
      </div>
      <div class="col-lg-4 text-center">
        <button class="btn-primary" @click="showModal">Добавить дилера</button>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="search">Поиск по фамилии</label>
          <input class="form-control" id="search" v-model="searchLastName"
                    @input="getFilteredDealerList()"
                    @focusin="InputFocusIn('search')"
                    @focusout="InputFocusOut('search')"/>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="search-phone">Поиск по телефону</label>
          <input class="form-control" id="search-phone" v-model="searchPhone"
                    @input="getFilteredDealerList()"
                    @focusin="InputFocusIn('search-phone')"
                    @focusout="InputFocusOut('search-phone')"/>
        </div>
      </div>
    </div>

    <div v-if="this.loading" class="col-lg-9">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <div v-else>
      <v-user-table :user-list="this.dealerList"
                    @update="closeModal" @close="closeModal" />
      <nav class="border pt-3" aria-label="navigation">
        <paginate
          :page-count="this.dealerList.total_pages"
          :click-handler="clickCallback"
          :prev-text="'Назад'"
          :next-text="'Вперед'"
          :container-class="'pagination justify-content-center'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'">
        </paginate>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VUserTable from '../../components/tables/v-user-table.vue';
import VUserCreateUpdateForm from '../../components/forms/v-user-create-update-form.vue';

export default {
  name: 'Dealers',
  components: { VUserCreateUpdateForm, VUserTable },
  computed: {
    ...mapState('user', ['dealerList']),
  },
  data() {
    return {
      isShowModal: false,
      loading: true,
      searchLastName: '',
      searchPhone: '',
      page: 1,
      fullFilter: '',
    };
  },
  methods: {
    ...mapActions('user', ['getDealerList']),
    clickCallback(pageNum) {
      this.page = pageNum;
      this.getFilteredDealerList();
    },
    getFilteredDealerList() {
      this.fullFilter = `?page=${this.page}`;
      if (this.searchLastName) {
        this.fullFilter += `&last_name=${this.searchLastName}`;
      }
      if (this.searchPhone) {
        this.fullFilter += `&contact_phone=${this.searchPhone}`;
      }
      this.getDealerList(this.fullFilter)
        .then(() => { this.loading = false; });
    },
    closeModal() {
      this.isShowModal = false;
      this.loading = true;
      this.getDealerList('')
        .then(() => { this.loading = false; });
    },
    showModal() {
      this.isShowModal = true;
    },
  },
  mounted() {
    this.getFilteredDealerList();
  },
};
</script>
